export const BASE_URL = process.env.REACT_APP_BASE_URL
export const TENANT_ID = process.env.REACT_APP_TENANT_ID
export const TENANT_DOMAIN = process.env.REACT_APP_TENANT_DOMAIN

